// @ai-generated 2026-08-18T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 5
import { UNARY_OPERATOR_LABEL } from '../fieldMetadata';
import type { SynqoPredicateCondition } from '@Model';
import { OperandRenderer } from './OperandRenderer';

interface PredicateRendererProps {
    node: SynqoPredicateCondition;
}

/**
 * Presence tests ("Bezeichnung ist befüllt"). Styled like a compare leaf but with no right-hand
 * side — the operator label is a complete predicate on its own.
 */
export function PredicateRenderer({ node }: PredicateRendererProps) {
    const opLabel = UNARY_OPERATOR_LABEL[node.operator];

    return (
        <div className="rounded border border-(--mantine-color-outline-5) bg-(--mantine-color-secondary-0) p-3 shadow-sm">
            <div className="flex flex-row flex-wrap items-center gap-2 text-sm">
                <OperandRenderer operand={node.operand} />
                <span className="text-(--mantine-color-text-5)">{opLabel}</span>
            </div>
            {node.message && <div className="mt-1 text-xs text-(--mantine-color-text-4)">{node.message}</div>}
        </div>
    );
}
